class TextAnimation {
    #animationTarget
    #text

    #animate() {
        if (!this.#text || !this.#animationTarget) return

        this.#animationTarget.replaceChildren()

        const offset = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 45 //ms
        let index = 0

        this.#text.split(/\s/).forEach(text => {
            const span = document.createElement("span")
            span.classList.add("nowrap")

            this.#animationTarget.append(span, document.createTextNode(" "))

            Array.from(text, char => this.#buildNode(char))
                .forEach((node) => {
                    window.setTimeout(() =>
                        span.appendChild(node), offset * index++
                    )
                })
        })
    }

    #buildNode(char) {
        if (char == "­") return document.createElement("wbr")

        const span = document.createElement("span")
        span.textContent = char.trim() ? char : "\xa0"
        span.classList.add("animate-appear")

        return span
    }

    #initIntersectionObserver(parent) {
        const observer = new IntersectionObserver(entries =>
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    observer.unobserve(entry.target)
                    this.#animate()
                }
            })
        )

        observer.observe(parent)
    }

    constructor(parent) {
        this.#animationTarget = parent.querySelector("[aria-hidden]")
        this.#text = parent.querySelector(".sr-only")?.textContent

        this.#initIntersectionObserver(parent)
    }
}

document.querySelectorAll("h2[data-animate=true]")
    .forEach(animation => new TextAnimation(animation))
